import React from "react";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { TimePicker, ConfigProvider, Space } from "antd";
import { ErrorMessage, useFormikContext } from "formik";
import { getValueFromPath } from "utils";
import dayjs from "dayjs";

dayjs.extend(customParseFormat);

const TimePickerField = ({
  name,
  label,
  placeholder,
  className,
  isRequired = false,
  disabled = false,
  isDynamic = false,
  timeFormat = "HH:mm:ss",
  needConfirm = true,
  use12Hours = false,
}) => {
  const { values, errors, touched, setFieldValue, setFieldTouched } =
    useFormikContext();

  const showError =
    (isDynamic ? getValueFromPath(errors, name) : errors[name]) &&
    (isDynamic ? getValueFromPath(touched, name) : touched[name]);
  const value = getValueFromPath(values, name);

  const handleTimeChange = (time) => {
    if (time && time.isValid()) {
      setFieldValue(name, time);
    } else {
      setFieldValue(name, null);
    }
  };

  return (
    <div className="form-control w-full">
      {label && (
        <div className="flex items-center gap-1 mb-1">
          <span className="flex gap-1 items-end">
            <span className="label-text dark:text-white">{label}</span>
            {isRequired && (
              <span className="text-red-500 font-extrabold">*</span>
            )}
          </span>
        </div>
      )}

      <ConfigProvider
        theme={{
          token: {
            colorTextPlaceholder: "#979797",
            colorBgContainerDisabled: "#f3f4f6",
            colorTextDisabled: "rgb(148 163 184)",
          },
        }}
      >
        <Space direction="vertical" size={12}>
          <TimePicker
            disabled={disabled}
            onBlur={() => setFieldTouched(name, true)}
            format={timeFormat}
            value={
              value
                ? dayjs.isDayjs(value)
                  ? value
                  : dayjs(value, timeFormat)
                : null
            }
            onChange={handleTimeChange}
            placeholder={placeholder}
            showNow={false}
            style={{
              width: "100%",
              height: "38px",
            }}
            className={`flex w-full border border-gray-300 placeholder-gray-300 text-gray-900 rounded-lg focus:outline-none
              dark:bg-slate-950 dark:focus-within:bg-white dark:focus-within:text-black dark:text-gray-300
              ${
                showError
                  ? "border focus-within:border-red-500 border-red-500 hover:border-red-500"
                  : "border dark:focus-within:border-[#FAB54E] focus-within:border-[#1996A6] hover:border-gray-300"
              }
              focus:z-10 sm:text-sm ${className} hover:none`}
            needConfirm={needConfirm}
            use12Hours={use12Hours}
          />
        </Space>
      </ConfigProvider>

      <ErrorMessage
        className="text-xs text-red-500 mt-1"
        name={name}
        component="div"
      />
    </div>
  );
};

export default TimePickerField;
